// extracted by mini-css-extract-plugin
export default {"newsContainer":"News_newsContainer__3H6UO"};